/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_DisabledInputs */

const en_users_disabled = /** @type {(inputs: Users_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disabled`)
};

const pt_br2_users_disabled = /** @type {(inputs: Users_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desabilitado`)
};

/**
* | output |
* | --- |
* | "Disabled" |
*
* @param {Users_DisabledInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_disabled = /** @type {((inputs?: Users_DisabledInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_DisabledInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_disabled(inputs)
	return pt_br2_users_disabled(inputs)
});